// This fetches and caches the mustache templates, and
// runs mustache on them

import $ from "jquery";
import * as Mustache from "mustache";
import * as _ from "underscore";

// map of filename (minus .mustache extension) to contents
const templateCache = {};
const templateNameToCallbacks = {};

const baseUrl = "/";

export const render = (templateName, data?, callback?) => {
  const async = callback ? true : false;
  let result;

  data = data || {};

  fetch(templateName, async, () => {
    result = Mustache.to_html(templateCache[templateName], data);
    if (async) {
      callback?.(result);
    }
  });

  if (!async) {
    return result;
  }
};

export const renderPromise = (templateName, data) =>
  new Promise((resolve) => {
    let result;
    data = data || {};

    fetch(templateName, true, () => {
      result = Mustache.to_html(templateCache[templateName], data);
      resolve(result);
    });
  });

export const fetch = (
  templateName,
  async = false,
  callback?: (html: string) => void
) => {
  if (templateName in templateCache) {
    callback?.(templateCache[templateName]);
  } else {
    if (templateNameToCallbacks[templateName]) {
      if (!async) {
        console.error(
          "Can't pre-fetch template before (deprecated) synchronous render() call"
        );
      }
      if (callback) {
        templateNameToCallbacks[templateName].push(callback);
      }
    } else {
      const callbackList = (templateNameToCallbacks[templateName] = []);
      if (callback) {
        callbackList.push(callback);
      }
      $.ajax({
        url:
          baseUrl +
          "templates/" +
          templateName +
          ".mustache?bust=" +
          window.READLANG.gitCommit,
        dataType: "text",
        success: function (fetchedTemplate) {
          templateCache[templateName] = fetchedTemplate;
          _.each(callbackList, (innerCallback) => {
            innerCallback(fetchedTemplate);
          });
          templateNameToCallbacks[templateName] = undefined;
        },
        error: function () {
          console.error("Couldn't fetch mustache template: " + templateName);
        },
        async: async,
      });
    }
  }
};
